import * as React from "react";
import { IdPremiumType } from "../../constants/IdPremiumType";
import { IdStyles } from "../../less/IdStyles";
import { Badge } from "../generic/badge/Badge";
import { ButtonInfoSmall } from "../generic/common/ButtonInfoSmall";
import { IconBuilding } from "../generic/common/icon-building/IconBuilding";
import { IdIconBuildingContext } from "../generic/common/icon-building/IdIconBuildingContext";
import { ImageBoxContainer } from "../generic/common/ImageBoxContainer";
import { Icon } from "../generic/icon/Icon";
import { IdIcon } from "../generic/icon/IdIcon";
import { StoreItemStats } from "./StoreItemStats";
export var StoreItemInformation = function (_a) {
    var item = _a.item, onInfoClick = _a.onInfoClick;
    var _b = item.balancing, packageIcon = _b.packageIcon, backgroundColor = _b.backgroundColor, buildingReward = _b.buildingReward, buildingRewardInfo = item.buildingRewardInfo, randomPoolRewardInfo = item.randomPoolRewardInfo;
    var imageBoxContainerClass = IdStyles.ImageBoxContainerSmall;
    if (backgroundColor && backgroundColor === IdPremiumType.Blue) {
        imageBoxContainerClass = IdStyles.ImageBoxContainerPremiumSmall;
    }
    var buildingIcon = React.createElement(Icon, { icon: packageIcon, styleId: IdStyles.IconExtraLarge });
    var infoIcon;
    if (buildingRewardInfo) {
        var stageId = buildingReward[0].stageId;
        var name = buildingRewardInfo.name;
        buildingIcon = (React.createElement(IconBuilding, { level: stageId, buildingName: name, context: IdIconBuildingContext.BuildDetail }));
    }
    if (buildingRewardInfo || randomPoolRewardInfo) {
        infoIcon = (React.createElement(Badge, null,
            React.createElement(ButtonInfoSmall, { onClick: onInfoClick },
                React.createElement(Icon, { icon: IdIcon.InfoIcn, styleId: IdStyles.IconSmall }))));
    }
    return (React.createElement("div", { className: "store-menu-detail__information" },
        React.createElement("div", { className: "store-menu-detail__information-image" },
            React.createElement(ImageBoxContainer, { className: imageBoxContainerClass + " flex flex--guts" },
                buildingIcon,
                infoIcon)),
        React.createElement(StoreItemStats, { item: item })));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/store/StoreItemInformation.tsx
// module id = 2760
// module chunks = 3